/**
 * Analytics loader — gated by REACT_APP_ENABLE_ANALYTICS + consent.analytics.
 * Default production: no-op. Session recording is always off.
 */

import { getConsent, onConsentChange } from "./consent";

let initialized = false;
let listening = false;

function envAllowsAnalytics() {
  return process.env.REACT_APP_ENABLE_ANALYTICS === "true";
}

function posthogCredentials() {
  const key = (process.env.REACT_APP_POSTHOG_KEY || "").trim();
  const host = (process.env.REACT_APP_POSTHOG_HOST || "").trim();
  if (!key || !host) return null;
  return { key, host };
}

/**
 * Injects PostHog only when env flag is on, consent.analytics is true, and keys exist.
 * Never enables session recording.
 */
export function initAnalyticsIfAllowed() {
  if (typeof window === "undefined") return;
  if (!envAllowsAnalytics()) return;
  if (initialized) return;

  const consent = getConsent();
  if (!consent?.analytics) return;

  const creds = posthogCredentials();
  if (!creds) return;

  // Dynamic loader — never present in public/index.html.
  !(function (t, e) {
    var o, n, p, r;
    e.__SV ||
      ((window.posthog = e),
      (e._i = []),
      (e.init = function (i, s, a) {
        function g(t, e) {
          var o = e.split(".");
          2 === o.length && ((t = t[o[0]]), (e = o[1]));
          t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        (p = t.createElement("script")).type = "text/javascript";
        p.crossOrigin = "anonymous";
        p.async = true;
        p.src =
          s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") +
          "/static/array.js";
        r = t.getElementsByTagName("script")[0];
        r.parentNode.insertBefore(p, r);
        var u = e;
        void 0 !== a ? (u = e[a] = []) : (a = "posthog");
        u.people = u.people || [];
        u.toString = function (t) {
          var e = "posthog";
          return (
            "posthog" !== a && (e += "." + a),
            t || (e += " (stub)"),
            e
          );
        };
        u.people.toString = function () {
          return u.toString(1) + ".people (stub)";
        };
        o =
          "init capture register register_once identify reset get_distinct_id".split(
            " ",
          );
        for (n = 0; n < o.length; n++) g(u, o[n]);
        e._i.push([i, s, a]);
      }),
      (e.__SV = 1));
  })(document, window.posthog || []);

  window.posthog.init(creds.key, {
    api_host: creds.host,
    person_profiles: "identified_only",
    persistence: "localStorage+cookie",
    disable_session_recording: true,
    session_recording: {
      enabled: false,
    },
  });

  initialized = true;
}

/** Subscribe once; call from app entry after mount. */
export function onConsentMaybeInit() {
  if (typeof window === "undefined") return;
  initAnalyticsIfAllowed();
  if (listening) return;
  listening = true;
  onConsentChange(() => {
    initAnalyticsIfAllowed();
  });
}
